import { render, staticRenderFns } from "./clientSelectPopup.vue?vue&type=template&id=661c7109&"
import script from "./clientSelectPopup.vue?vue&type=script&lang=js&"
export * from "./clientSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./clientSelectPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports